import type {
  PersonaScriptHookDto,
  PersonaScriptSceneDto,
} from "@/features/persona-opportunities/api/persona-opportunity-scripts.api";

const HOOK_SCENE_NAME = "hook";

/** Scene named "hook", else scene 1 — the scene a hook's voiceover lives in. */
export function findHookSceneNumber(scenes: PersonaScriptSceneDto[]): number | undefined {
  return (
    scenes.find((scene) => scene.sceneName.trim().toLowerCase() === HOOK_SCENE_NAME) ??
    scenes.find((scene) => scene.sceneNumber === 1)
  )?.sceneNumber;
}

/**
 * Scenes as they read with `hook` opening the video; nothing is saved. Scenes
 * have no on-screen text field, so the hook's on-screen text joins the hook
 * scene's seeing.
 */
export function scenesWithPreviewedHook(
  scenes: PersonaScriptSceneDto[],
  hook: PersonaScriptHookDto | undefined,
  formatOnScreenText: (text: string) => string,
): PersonaScriptSceneDto[] {
  if (!hook) return scenes;
  const hookSceneNumber = findHookSceneNumber(scenes);
  const onScreenText = hook.onScreenText?.trim();
  return scenes.map((scene) =>
    scene.sceneNumber === hookSceneNumber
      ? {
          ...scene,
          hearing: hook.voiceover,
          seeing: onScreenText
            ? [scene.seeing.trim(), formatOnScreenText(onScreenText)].filter(Boolean).join("\n\n")
            : scene.seeing,
        }
      : scene,
  );
}
